export default "__VITE_ASSET__BlVrKCNY__"